/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AuthVisitorAuthenticationCodeVerifiyRequestFromJSON(json) {
    return AuthVisitorAuthenticationCodeVerifiyRequestFromJSONTyped(json, false);
}
export function AuthVisitorAuthenticationCodeVerifiyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        code: !exists(json, 'code') ? undefined : json['code']
    };
}
export function AuthVisitorAuthenticationCodeVerifiyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        code: value.code
    };
}
